<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<section class="orbit-aside-layout" data-aside-version="2">
	<header class="orbit-aside-layout__header">
		<ng-content select="[orbitAsideHeader]"></ng-content>
	</header>
	<div class="orbit-aside-layout__body">
		<ng-content select="[orbitAsideBody]"></ng-content>
	</div>
	<footer class="orbit-aside-layout__footer" [class.orbit-aside-layout__footer--suppressed]="hasOutcomeActions === false">
		<ng-content select="[orbitAsideFooter]"></ng-content>
	</footer>
</section>
